import './App.css';
import figlet from 'figlet';
import standard from 'figlet/importable-fonts/Standard.js';
import React, { useState } from 'react';

function App() {
  const [inputString, setInputString] = useState( "" );
  const [resultStrings, setResultStrings] = useState( "" );

  const generateResult = () => {
    figlet.parseFont('Standard', standard);
    console.log( inputString );
    figlet.text(inputString, {
        font: 'Standard',
    }, function(err, data) {
        setResultStrings(data);
        console.log(data);
    });
  }

  return (
    <div className="App">
      <div className='container'>
        <div className='generator'>
          <h2 className='title'>Art Text Generator</h2>
          <div className='input_line'>
            <label htmlFor='input-string'>Input: </label>
            &nbsp;&nbsp;&nbsp;
            <input
              defaultValue={inputString}
              onChange={function (e){ setInputString(e.target.value); generateResult(); }}
              type='string'
              id='input-string'
              name='input-string'
              color='rgb(0,0,0)'
              size='50'
              placeholder="your words"
            />
          </div>
          <div className='form-group'>
            <button onClick={generateResult} className='generate_btn'>Update</button>
          </div>
          <div className='form-group'>
            <textarea defaultValue={resultStrings} className='resultStrings'></textarea>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
